import router from '@/router'

export default {
  name: 'EngagementPage',
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    redirectTo(url) {
      if(url) {
        this.$router.push(url)
      }
    }
  },
  computed: {
  }
}



// WEBPACK FOOTER //
// ./src/views/pages/engagement/engagement.component.js